import { Card, Col, Container, Row } from 'react-bootstrap';
import { motion } from "motion/react";
import marketData from '../../data/marketData.json';

const Timeline = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  }

  const cardVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  }

  const progressVariants = {
    hidden: { width: 0 },
    visible: (progress) => ({
      width: `${progress}%`,
      transition: { duration: 1, ease: "easeOut", delay: 0.3 }
    })
  }

  return (
    <section className='section-lg overflow-hidden' id='market-timeline'>
      <Container>
        <Row>
          <Col xs={12} className='mb-5'>
            <motion.h6 initial={{ opacity: 0, y: -30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="underline-after position-relative text-center z-0">
              <span className="position-relative z-1 bg-white text-primary px-3">Timeline</span>
            </motion.h6>
            <motion.h1 initial={{ opacity: 0, scale: 0 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="d-block text-gradiant text-center fw-semibold">From kickoff to insights</motion.h1>
          </Col>
        </Row>
        <Row className="g-4 justify-content-center">
          <Col md={10}>
            <motion.div
              variants={containerVariants}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
            >
              <Row className="g-4 align-items-stretch">
                {marketData.timeline.map((item, index) => (
                  <Col md={6} key={item.id}>
                    <motion.div variants={cardVariants}
                      whileHover={{ y: -5, scale: 1.02, transition: { duration: 0.3 } }}
                    >
                      <Card className={`h-100 shadow-sm border-0 ${index % 2 !== 0 ? 'ms-md-auto' : ''}`}>
                        <Card.Body>
                          <div className="d-flex align-items-center mb-2">
                            <motion.span className="badge bg-success me-2" whileHover={{ scale: 1.1 }}>
                              {item.week}
                            </motion.span>
                            <h6 className="mb-0">{item.title}</h6>
                          </div>
                          <p className="text-secondary mb-3">{item.description}</p>
                          <div style={{ height: '6px', backgroundColor: '#e9ecef', borderRadius: '3px', overflow: 'hidden' }}>
                            <motion.div
                              style={{ height: '100%', backgroundColor: '#198754' }}
                              variants={progressVariants}
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true }}
                              custom={item.progress}
                            />
                          </div>
                        </Card.Body>
                      </Card>
                    </motion.div>
                  </Col>
                ))}
              </Row>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Timeline;